var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductLister',{attrs:{"breadcrumbs":_vm.breadcrumbs,"category-title":_vm.title,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }